import { TRequestForFirm } from "./types";

export function createRequestForFirm(
  values: Partial<TRequestForFirm>
): TRequestForFirm {
  // You can add defaults or validation here if needed
  return {
    recipientWhatsAppId: values.recipientWhatsAppId ?? "",
    // Store created as ISO UTC for consistency
    created: new Date().toISOString(),
    vesselImo: values.vesselImo ?? "",
    vesselName: values.vesselName ?? "",
    destinationPort: values.destinationPort ?? "",
    eta: values.eta ?? "",
    laycanFrom: values.laycanFrom ?? "",
    laycanTo: values.laycanTo ?? "",
    remarks: values.remarks ?? "",
    port: values.port ?? "",
    lineItems: values.lineItems ?? [],
    clientDomain: values.clientDomain ?? "",
    email: values.email ?? "",
    metadataJson: values.metadataJson ?? undefined,
    extrasJson: values.extrasJson ?? undefined,
  };
}
